import http from "../../http";
import ApiConstants from "../../constants/ApiConstants";

class PolicyAndResourcesService {
	static API_CONFIG = {
		currentPage: 1,
		limit: 20,
		order: "desc",
		field: "createdAt",
	};

	static COLUMN_CONFIG = [
		{
			name: "Document Name",
			type: "text",
			index: 0,
			required: false,
			width: 400,
			editable: true,
			hidden: false,
			uiVisible: true,
			systemField: true,
			columnCode: "name",
			key: "name",
			textAlign: "left",
		},
		{
			name: "Document Description",
			type: "text",
			index: 1,
			required: false,
			width: 600,
			editable: true,
			hidden: false,
			uiVisible: true,
			systemField: true,
			columnCode: "description",
			key: "description",
			textAlign: "left",
		},
	];

	static getPolicyAndResourceDocuments() {
        const params = this.API_CONFIG;

		return http.get(ApiConstants.URL.POLICY_AND_RESOURCES.GET, { params: params }).catch((error) => {
			console.error("Error while fetching policy and resource documents: ", error);
			return Promise.reject(error);
		});
	}

	static savePolicyAndResourceDocument(payload) {
		return http.post(ApiConstants.URL.POLICY_AND_RESOURCES.POST, payload).catch((error) => {
			console.error("Error while adding policy and resource document: ", error);
			return Promise.reject(error);
		});
	}

	static deletePolicyAndResourceDocument(payload) {
		return http.delete(ApiConstants.URL.POLICY_AND_RESOURCES.DELETE, { data: payload}).catch((error) => {
			console.error("Error while deleting policy and resource documents: ", error);
			return Promise.reject(error);
		});
	}
}

export default PolicyAndResourcesService;
